import { Component } from '@angular/core';

@Component({
  selector: 'app-claim-type-create',
  templateUrl: './claim-type-create.component.html',
  styleUrls: ['./claim-type-create.component.scss'],
  standalone: false,
})
export class ClaimTypeCreateComponent {}
